// export const BASE_API = "http://localhost:5001";
export const BASE_API = "https://api.deepcare.net/api";
export const ROOT_WEB_URL = "https://www.deepview.win";
export const ACCEPTED_TOLERANCE = 3;
